import isEqual from '../objects/isEqual';

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @return {Array}
 */
export default function objectDiff(a, b) {
  const diff = new Set();

  // empty states
  if (!a && !b) return [];
  if (!a?.size && b?.size) return b;
  if (!b?.size && a?.size) return a;

  // check if items in A exist in B
  a.forEach((i) => {
    b.some((j) => isEqual(i, j)) || diff.add(i);
  });

  // check if items in B exist in A
  b.forEach((i) => {
    a.some((j) => isEqual(i, j)) || diff.add(i);
  });

  return Array.from(diff);
}
